module.exports = __webpack_public_path__ + "img/logo.19c804b0.png";